import { render, staticRenderFns } from "./NormalSearchNav60.vue?vue&type=template&id=36bd0420&scoped=true&"
import script from "./NormalSearchNav60.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav60.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bd0420",
  null
  
)

export default component.exports